import React from "react";
import "./styles/EmptyState.css";

/**
 * EmptyState - Placeholder for an empty or fully filtered-out list.
 *
 * Give it a `title` when there is nothing at all yet and an `action`
 * that gets the user unstuck; `message` alone is enough for the
 * "nothing matches these filters" case.
 *
 * @param {React.ReactNode} props.icon - Optional icon
 * @param {string} props.title - Short headline
 * @param {string} props.message - Supporting sentence
 * @param {React.ReactNode} props.action - Optional button
 */
const EmptyState = ({ icon, title, message, action }) => {
  return (
    <div className="emptyState">
      {icon && <div className="emptyStateIcon">{icon}</div>}
      {title && <div className="emptyStateTitle">{title}</div>}
      {message && <div className="emptyStateMessage">{message}</div>}
      {action && <div className="emptyStateAction">{action}</div>}
    </div>
  );
};

export default EmptyState;
